
import ConfirmOrder from '../views/ConfirmOrder' // 确认订单

const otherRouter = [
  {
    path: '/confirmOrder',
    name: 'confirmOrder',
    component: ConfirmOrder,
    children: []
  }
]

export default otherRouter



// WEBPACK FOOTER //
// ./src/router/otherRouters.js